module.exports = __webpack_public_path__ + "img/package.21e45b98.svg";